var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('header-row',{attrs:{"cols":_vm.cols}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }